<template>
  <div>
    <!-- Start Blog Area -->
    <div class="blog-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                text-align="center"
                subtitle="Latest News"
                title="最新动态"
                description=""
                data-aos="fade-up"
            />
          </div>
        </div>
        <div class="row row--15">
          <div class="col-lg-4 col-md-6 col-sm-12 col-12 mt--30"
               data-aos="slide-up"
               data-aos-duration="800"
               :data-aos-delay="100 + index"
               v-for="(blog, index) in posts"
               :key="index"
               v-if="index < 6">
            <BlogPost :blog="blog"/>
          </div>
        </div>
      </div>
    </div>
    <!-- End Blog Area -->
  </div>

</template>

<script>
import Icon from '../../icon/Icon'
import Video from "../video/Video";
import SectionTitle from "@/components/elements/sectionTitle/SectionTitle";
import BlogPost from "@/components/blog/BlogPost";
import Separator from "@/components/elements/separator/Separator";
export default {
  name: 'AboutEight',
  components: {Video, Icon,SectionTitle,BlogPost,Separator},
  props: {
    image: {}
  },
  data() {
    return {
      videoData: [
        {
          thumb: this.image,
          src: 'https://www.youtube.com/watch?v=d0tU18Ybcvk',
        }
      ],
      posts: [
        {
          id: '1',
          img: require(`@/assets/images/blog/blog-01.jpg`),
          publishedAt: '2023-06-01 15:35',
          title: '6.1 | 童心永恒，梦想不止',

          url: 'https://mp.weixin.qq.com/s/BYHQCpv9gcvC89HsftGsWg'
        },
        {
          id: '1',
          img: require(`@/assets/images/blog/blog-01.jpg`),
          publishedAt: '2023-06-01 15:35',
          title: '6.1 | 童心永恒，梦想不止',

          url: 'https://mp.weixin.qq.com/s/BYHQCpv9gcvC89HsftGsWg'
        },
        {
          id: '1',
          img: require(`@/assets/images/blog/blog-01.jpg`),
          publishedAt: '2023-06-01 15:35',
          title: '6.1 | 童心永恒，梦想不止',

          url: 'https://mp.weixin.qq.com/s/BYHQCpv9gcvC89HsftGsWg'
        },
        {
          id: '1',
          img: require(`@/assets/images/blog/blog-01.jpg`),
          publishedAt: '2023-06-01 15:35',
          title: '6.1 | 童心永恒，梦想不止',

          url: 'https://mp.weixin.qq.com/s/BYHQCpv9gcvC89HsftGsWg'
        },
        {
          id: '1',
          img: require(`@/assets/images/blog/blog-01.jpg`),
          publishedAt: '2023-06-01 15:35',
          title: '6.1 | 童心永恒，梦想不止',

          url: 'https://mp.weixin.qq.com/s/BYHQCpv9gcvC89HsftGsWg'
        },

      ],
    }
  }
}
</script>